export default "__VITE_ASSET__1sFYgO8M__"